import React from 'react';
import Add2WalletLogo from './Add2WalletLogo';

const PageFooter: React.FC = () => (
  <footer className="mt-8 pt-6 border-t border-[#E4EAE2]">
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-8">
      <div className="flex items-start gap-2.5">
        <svg className="w-5 h-5 text-gray-400 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M12 3l8 3v6c0 4.5-3.2 7.7-8 9-4.8-1.3-8-4.5-8-9V6l8-3z" />
        </svg>
        <p className="text-xs text-gray-500 max-w-xs">
          Your privacy is important to us. We never share your personal information.
        </p>
      </div>
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <span>Powered by</span>
        <Add2WalletLogo size={20} />
      </div>
    </div>
  </footer>
);

export default PageFooter;
